// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as SupUnitCard from "../set-update/SupUnitCard.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as UnitInfoPage from "./UnitInfoPage.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as ListGridSelect from "../stats/ListGridSelect.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Input from "@mui/material/Input";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Clear from "@mui/icons-material/Clear";
import FormControl from "@mui/material/FormControl";
import Search from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

function UnitsInfoPage$Itemization(Props) {
  var typ = Props.typ;
  var itemization = Props.itemization;
  var t = Translation.useT(/* Common */0);
  return React.createElement(Tooltip.make, {
              title: React.createElement("div", {
                    className: "flex flex-col items-start"
                  }, React.createElement("div", {
                        className: "font-montserrat font-medium text-[15px] pb-[6px]"
                      }, t(typ + "_items")), React.createElement("div", {
                        className: "font-roboto text-[12px] pb-2 max-w-[200px]"
                      }, t(typ + "_desc")), React.createElement("div", {
                        className: "grid grid-cols-4 gap-2 flex-shrink-1"
                      }, Belt_Array.map(itemization, (function (itemId) {
                              return React.createElement(ItemImage.make, {
                                          itemId: itemId,
                                          size: 36,
                                          rounded: "rounded",
                                          key: itemId
                                        });
                            })))),
              children: React.createElement("div", {
                    className: "mb-2 bg-bg2 rounded-lg px-2 py-1 font-montserrat font-medium self-start"
                  }, t(typ))
            });
}

var Itemization = {
  make: UnitsInfoPage$Itemization
};

function UnitsInfoPage$UnitAbilityInfo(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  var unitsT = Translation.useT(/* Units */1);
  var basePath = CdnAtom.usePath(undefined);
  var basePath3 = CdnAtom.usePath4(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex items-center mt-1 mb-2"
                }, React.createElement("img", {
                      className: "rounded flex-shrink-0 w-[22px] h-[22px]",
                      height: "22",
                      src: basePath3 + "/ability/" + unitId + ".jpg?w=22",
                      width: "22"
                    }), React.createElement("div", {
                      className: "flex items-center pl-2 leading-none"
                    }, React.createElement("div", {
                          className: "font-medium text-sm"
                        }, unitId === "TFT9_Ryze" ? "Realm Warp" : unitsT(unitId + "_ability")), info.stats.mana > 0 ? React.createElement("div", {
                            className: "flex items-center pt-[2px] h-[18px] text-sm pl-2"
                          }, React.createElement("div", {
                                className: "mt-[-1px] mr-[2px] w-[14px] h-[14px]"
                              }, React.createElement("img", {
                                    alt: "Mana",
                                    height: "14",
                                    src: basePath + "/general/mana.png",
                                    width: "14"
                                  })), React.createElement("div", {
                                className: "pt-[1px]"
                              }, String(info.stats.initialMana) + "/" + String(info.stats.mana))) : null)), React.createElement(RitoDescription2.make, {
                  desc: unitsT(unitId + "_desc")
                }), React.createElement(UnitTooltip.AbilityDetails.make, {
                  unitId: unitId,
                  info: info
                }));
}

var UnitAbilityInfo = {
  make: UnitsInfoPage$UnitAbilityInfo
};

function UnitsInfoPage$UnitAbility(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  Translation.useT(/* Units */1);
  CdnAtom.usePath(undefined);
  CdnAtom.usePath4(undefined);
  var itemization = Belt_Option.flatMap(info.itemization, (function (itmz) {
          return Js_dict.get(Data13.data.itemization, itmz);
        }));
  return React.createElement("div", {
              className: "p-3 flex flex-col text-sm"
            }, itemization !== undefined ? React.createElement(UnitsInfoPage$Itemization, {
                    typ: Belt_Option.getExn(info.itemization),
                    itemization: itemization
                  }) : null, React.createElement(UnitsInfoPage$UnitAbilityInfo, {
                  unitId: unitId,
                  info: info
                }));
}

var UnitAbility = {
  make: UnitsInfoPage$UnitAbility
};

function UnitsInfoPage$UnitTraits(Props) {
  var unitId = Props.unitId;
  var traitsT = Translation.useT(/* Traits */2);
  var set = TftSet.use(undefined);
  var traits = Sd.getUnitTraits(unitId, set);
  return React.createElement("div", {
              className: "p-3 flex flex-col gap-4"
            }, Belt_Array.map(traits, (function (traitId) {
                    return React.createElement("div", {
                                key: traitId,
                                className: "text-sm"
                              }, React.createElement("div", {
                                    className: "flex items-center gap-[2px] pb-[6px]"
                                  }, React.createElement(TraitImage.PlainIcon.make, {
                                        traitId: traitId,
                                        size: 22
                                      }), React.createElement("h3", {
                                        className: "inline-block text-base font-montserrat font-medium"
                                      }, traitsT(traitId))), React.createElement(RitoDescription2.make, {
                                    desc: traitsT(traitId + "_desc")
                                  }));
                  })));
}

var UnitTraits = {
  make: UnitsInfoPage$UnitTraits
};

function UnitsInfoPage$UnitStats(Props) {
  var unitId = Props.unitId;
  var info = Props.info;
  return React.createElement("div", {
              className: "py-3 px-4"
            }, React.createElement(UnitInfoPage.StatsGrid.make, {
                  unitId: unitId,
                  info: info
                }));
}

var UnitStats = {
  make: UnitsInfoPage$UnitStats
};

function UnitsInfoPage$Upgrade(Props) {
  var itemId = Props.itemId;
  var t = Translation.useT(/* Items */3);
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex items-center gap-2 pb-1"
                }, React.createElement(ItemImage.make, {
                      itemId: itemId,
                      size: 26
                    }), React.createElement("div", undefined, t(Data.encodeItemId(itemId)))), React.createElement("div", {
                  className: "text-sm leading-tight"
                }, React.createElement(RitoDescription2.make, {
                      desc: t(Data.encodeItemId(itemId + "_desc"))
                    })));
}

var Upgrade = {
  make: UnitsInfoPage$Upgrade
};

function UnitsInfoPage$UnitCard(Props) {
  var unitId = Props.unitId;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return /* Ability */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var traits = Sd.getUnitTraits(unitId, set);
  var info = Belt_Option.getExn(Dict.get(Data.units(set), unitId));
  var tmp;
  switch (tab) {
    case /* Ability */0 :
        tmp = React.createElement(UnitsInfoPage$UnitAbility, {
              unitId: unitId,
              info: info
            });
        break;
    case /* Traits */1 :
        tmp = unitId !== "TFT11_Kayle" ? React.createElement(UnitsInfoPage$UnitTraits, {
                unitId: unitId
              }) : React.createElement("div", {
                className: "p-4 flex flex-col gap-2"
              }, React.createElement("h3", {
                    className: "h3 pt-0 pb-1"
                  }, "Level 1 Effect Options"), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver3_AS"
                  }), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver3_AP"
                  }), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver3_Support"
                  }), React.createElement("h3", {
                    className: "h3 pt-4 pb-1"
                  }, "Level 2 Effect Options"), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver5_AS"
                  }), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver5_AP"
                  }), React.createElement("h3", {
                    className: "h3 pt-4 pb-1"
                  }, "Level 3 Effect Options"), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver7_AS"
                  }), React.createElement(UnitsInfoPage$Upgrade, {
                    itemId: "TFT11_Storyweaver7_Support"
                  }));
        break;
    case /* Stats */2 :
        tmp = React.createElement(UnitsInfoPage$UnitStats, {
              unitId: unitId,
              info: info
            });
        break;
    
  }
  return React.createElement(ContentSection.make, {
              className: "w-[291px] flex flex-col h-full",
              children: null,
              noPadding: true
            }, React.createElement(Link.make, {
                  route: {
                    TAG: /* Info */6,
                    _0: {
                      TAG: /* Unit */0,
                      _0: set,
                      _1: unitId
                    }
                  },
                  children: React.createElement(SupUnitCard.make, {
                        unitId: unitId,
                        traits: traits,
                        width: 290
                      })
                }), tmp, React.createElement(Tabs, {
                  classes: {
                    root: "mt-auto"
                  },
                  children: null,
                  value: tab,
                  onChange: (function (param, t) {
                      return Curry._1(setTab, (function (param) {
                                    return t;
                                  }));
                    })
                }, React.createElement(Tab, {
                      label: t("Ability"),
                      value: /* Ability */0,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    }), React.createElement(Tab, {
                      label: t(unitId === "TFT11_Kayle" ? "Effects" : "Traits"),
                      value: /* Traits */1,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    }), React.createElement(Tab, {
                      label: t("Stats"),
                      value: /* Stats */2,
                      classes: {
                        root: "min-w-[97px]"
                      }
                    })));
}

var UnitCard = {
  make: UnitsInfoPage$UnitCard
};

function UnitsInfoPage$UnitsGrid(Props) {
  var unitIds = Props.unitIds;
  var search = Props.search;
  var originFilter = Props.originFilter;
  var classFilter = Props.classFilter;
  var searchUnitIds = Props.searchUnitIds;
  var set = TftSet.use(undefined);
  var filteredUnits = Belt_Array.keep(unitIds, (function (unitId) {
          var search$1 = search.toLowerCase();
          var traits = Sd.getUnitTraits(unitId, set);
          var searchMatch = search$1 === "" || searchUnitIds.includes(unitId);
          if (searchMatch && (originFilter === "any" || traits.includes(originFilter))) {
            if (classFilter === "any") {
              return true;
            } else {
              return traits.includes(classFilter);
            }
          } else {
            return false;
          }
        }));
  if (filteredUnits.length === 0) {
    return null;
  } else {
    return React.createElement("div", {
                className: "py-8 grid items-stretch grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
              }, Belt_Array.map(filteredUnits, (function (unitId) {
                      if (unitId === "TFT11_Norra") {
                        return React.createElement(React.Fragment, {
                                    children: null,
                                    key: unitId
                                  }, React.createElement(UnitsInfoPage$UnitCard, {
                                        unitId: unitId
                                      }), React.createElement(UnitsInfoPage$UnitCard, {
                                        unitId: "TFT11_Yuumi"
                                      }));
                      } else if (Sd.getUnitTraits(unitId, set).includes("TFT13_FormSwapper")) {
                        return React.createElement(React.Fragment, {
                                    children: null,
                                    key: unitId
                                  }, React.createElement(UnitsInfoPage$UnitCard, {
                                        unitId: unitId
                                      }), React.createElement(UnitsInfoPage$UnitCard, {
                                        unitId: unitId + "_Ranged"
                                      }));
                      } else {
                        return React.createElement(UnitsInfoPage$UnitCard, {
                                    unitId: unitId,
                                    key: unitId
                                  });
                      }
                    })));
  }
}

var UnitsGrid = {
  make: UnitsInfoPage$UnitsGrid
};

function UnitsInfoPage$GridView(Props) {
  var search = Props.search;
  var originFilter = Props.originFilter;
  var classFilter = Props.classFilter;
  var costFilter = Props.costFilter;
  var set = TftSet.use(undefined);
  var searchUnitIds = React.useMemo((function () {
          if (search !== "") {
            return Search2.searchUnitsArr(search, set);
          } else {
            return [];
          }
        }), [search]);
  return React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(Belt_Array.keep([
                      1,
                      2,
                      3,
                      4,
                      5,
                      6
                    ], (function (rarity) {
                        if (costFilter === "Any Cost") {
                          return true;
                        } else {
                          return Caml_obj.caml_equal(rarity, Belt_Int.fromString(costFilter));
                        }
                      })), (function (idx, rarity) {
                    return React.createElement(UnitsInfoPage$UnitsGrid, {
                                unitIds: Belt_Array.keep(Sd.allUnits(set), (function (unitId) {
                                        return Sd.unitTier(unitId) === rarity;
                                      })),
                                search: search,
                                originFilter: originFilter,
                                classFilter: classFilter,
                                costFilter: costFilter,
                                searchUnitIds: searchUnitIds,
                                key: String(idx)
                              });
                  })));
}

var GridView = {
  make: UnitsInfoPage$GridView
};

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Unit");
        }), undefined, (function (param, param$1, param$2) {
          var unitId = param[0];
          return React.createElement(React.Fragment, undefined, React.createElement("div", {
                          className: "pr-[6px] flex-shrink-0"
                        }, React.createElement(UnitTooltip.make, {
                              unit: unitId,
                              children: React.createElement(UnitImage.make, {
                                    unitId: unitId,
                                    size: 28
                                  })
                            })), React.createElement("div", {
                          className: "truncate"
                        }, React.createElement(UnitName0.make, {
                              unit: unitId
                            })));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param$2.unitsT(param[0]);
        }), undefined, 150, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Cost");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, String(Sd.unitCost(param[0], param$2.set)));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return Sd.unitCost(param[0], param$2.set);
        }), undefined, 60, undefined, undefined),
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Origin");
        }), undefined, (function (param, param$1, param$2) {
          var traits = Belt_Array.keepU(Sd.getUnitTraits(param[0], param$2.set), Sd.isOrigin);
          return React.createElement(React.Fragment, undefined, Belt_Array.map(traits, (function (traitId) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: traitId,
                                        children: React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              size: 22
                                            })
                                      });
                          })));
        }), "gap-1", undefined, undefined, (function (param, param$1, param$2) {
          var traitId = Belt_Array.get(Belt_Array.keepU(Sd.getUnitTraits(param[0], param$2.set), Sd.isOrigin), 0);
          if (traitId !== undefined) {
            return param$2.traitsT(traitId);
          } else {
            return "";
          }
        }), undefined, 75, undefined, undefined),
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Class");
        }), undefined, (function (param, param$1, param$2) {
          var traits = Belt_Array.keepU(Sd.getUnitTraits(param[0], param$2.set), Sd.isClass);
          return React.createElement(React.Fragment, undefined, Belt_Array.map(traits, (function (traitId) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: traitId,
                                        children: React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              size: 22
                                            })
                                      });
                          })));
        }), "gap-1", undefined, undefined, (function (param, param$1, param$2) {
          var traitId = Belt_Array.getExn(Belt_Array.keepU(Sd.getUnitTraits(param[0], param$2.set), Sd.isClass), 0);
          return param$2.traitsT(traitId);
        }), undefined, 75, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Health");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, String(param[1].stats.hp));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.hp;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Armor");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, String(param[1].stats.armor));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.armor;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("MR");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, String(param[1].stats.magicResist));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.magicResist;
        }), undefined, 65, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("AD");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, String(param[1].stats.damage));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.damage;
        }), undefined, 65, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("AS");
        }), undefined, (function (param, param$1, param$2) {
          return React.createElement("div", undefined, Global.toFixed(undefined, param[1].stats.attackSpeed));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.attackSpeed;
        }), undefined, 65, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("DPS");
        }), undefined, (function (param, param$1, param$2) {
          var v = param[1];
          return React.createElement("div", undefined, (Global.f(v.stats.damage) * v.stats.attackSpeed).toFixed());
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          var v = param[1];
          return Global.f(v.stats.damage) * v.stats.attackSpeed;
        }), undefined, 65, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Mana");
        }), undefined, (function (param, param$1, param$2) {
          var v = param[1];
          return React.createElement("div", undefined, String(v.stats.initialMana) + "/" + String(v.stats.mana));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].stats.mana;
        }), undefined, 85, undefined, undefined)
];

function UnitsInfoPage$ListView(Props) {
  var search = Props.search;
  var originFilter = Props.originFilter;
  var classFilter = Props.classFilter;
  var costFilter = Props.costFilter;
  var set = TftSet.use(undefined);
  var searchUnits = React.useMemo((function () {
          if (search === "") {
            return Sd.allUnits2(set);
          } else {
            return Search2.searchUnitsArr(search, set);
          }
        }), [search]);
  var data = React.useMemo((function () {
          var filteredUnits = Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
                  var searchMatch = search === "" || searchUnits.includes(unitId);
                  var traits = Sd.getUnitTraits(unitId, set);
                  if (!(searchMatch && (originFilter === "any" || traits.includes(originFilter)) && (classFilter === "any" || traits.includes(classFilter)))) {
                    return false;
                  }
                  var cost = Belt_Int.fromString(costFilter);
                  if (cost !== undefined) {
                    return Sd.unitCost(unitId, set) === cost;
                  } else {
                    return true;
                  }
                }));
          return Belt_Array.map(filteredUnits, (function (uid) {
                        return [
                                uid,
                                Dict.getExn(Data.units(set), uid)
                              ];
                      }));
        }), [
        search,
        originFilter,
        classFilter,
        costFilter
      ]);
  var keyFn = React.useCallback((function (v) {
          return v[0];
        }), []);
  return React.createElement(ContentSection.make, {
              className: "mt-8",
              children: React.createElement(StatsTable2.make, {
                    cols: cols,
                    data: data,
                    context: undefined,
                    keyFn: keyFn,
                    stickyColCount: 1,
                    defaultSortIdx: 1
                  }),
              noPadding: true
            });
}

var ListView = {
  cols: cols,
  make: UnitsInfoPage$ListView
};

function UnitsInfoPage$Filters(Props) {
  var search = Props.search;
  var setSearch = Props.setSearch;
  var originFilter = Props.originFilter;
  var setOriginFilter = Props.setOriginFilter;
  var classFilter = Props.classFilter;
  var setClassFilter = Props.setClassFilter;
  var costFilter = Props.costFilter;
  var setCostFilter = Props.setCostFilter;
  var t = Translation.useT(/* Common */0);
  var traitsT = Translation.useT(/* Traits */2);
  var screenSize = ScreenAtom.use(undefined);
  var set = TftSet.use(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex flex-col sm:flex-row gap-4"
                }, React.createElement(FormControl, {
                      children: React.createElement(Input, {
                            classes: {
                              root: "w-[200px]"
                            },
                            placeholder: t("Search by name/trait"),
                            value: search,
                            onChange: (function (e) {
                                var v = e.target.value;
                                return Curry._1(setSearch, (function (param) {
                                              return v;
                                            }));
                              }),
                            startAdornment: React.createElement(InputAdornment, {
                                  position: "start",
                                  children: React.createElement(Search, {
                                        color: "inherit"
                                      })
                                }),
                            endAdornment: search !== "" ? React.createElement("div", {
                                    className: "cursor-pointer",
                                    onClick: (function (param) {
                                        return Curry._1(setSearch, (function (param) {
                                                      return "";
                                                    }));
                                      })
                                  }, React.createElement(InputAdornment, {
                                        position: "end",
                                        children: React.createElement(Clear, {
                                              fontSize: "small",
                                              color: "inherit"
                                            })
                                      })) : null
                          })
                    }), React.createElement(Select, {
                      native: screenSize >= 4,
                      value: originFilter,
                      onChange: (function (e) {
                          var v = e.target.value;
                          return Curry._1(setOriginFilter, (function (param) {
                                        return v;
                                      }));
                        }),
                      className: "w-[160px]",
                      variant: "standard",
                      children: null
                    }, screenSize >= 4 ? React.createElement("option", {
                            value: "any"
                          }, "Any Origin") : React.createElement(MenuItem, {
                            value: "any",
                            children: "Any Origin"
                          }), Belt_Array.map(Sd.allOrigins(set), (function (traitId) {
                            if (screenSize >= 4) {
                              return React.createElement("option", {
                                          key: traitId,
                                          value: traitId
                                        }, traitsT(traitId));
                            } else {
                              return React.createElement(MenuItem, {
                                          value: traitId,
                                          children: React.createElement("div", {
                                                className: "flex items-center"
                                              }, React.createElement(TraitImage.PlainIcon.make, {
                                                    traitId: traitId,
                                                    size: 24
                                                  }), React.createElement("div", {
                                                    className: "pl-1"
                                                  }, traitsT(traitId))),
                                          key: traitId
                                        });
                            }
                          })))), React.createElement("div", {
                  className: "flex gap-4"
                }, React.createElement(Select, {
                      native: screenSize >= 4,
                      value: classFilter,
                      onChange: (function (e) {
                          var v = e.target.value;
                          return Curry._1(setClassFilter, (function (param) {
                                        return v;
                                      }));
                        }),
                      className: "w-[160px]",
                      variant: "standard",
                      children: null
                    }, screenSize >= 4 ? React.createElement("option", {
                            value: "any"
                          }, "Any Class") : React.createElement(MenuItem, {
                            value: "any",
                            children: "Any Class"
                          }), Belt_Array.map(Sd.allClasses(set), (function (traitId) {
                            if (screenSize >= 4) {
                              return React.createElement("option", {
                                          key: traitId,
                                          value: traitId
                                        }, traitsT(traitId));
                            } else {
                              return React.createElement(MenuItem, {
                                          value: traitId,
                                          children: React.createElement("div", {
                                                className: "flex items-center"
                                              }, React.createElement(TraitImage.PlainIcon.make, {
                                                    traitId: traitId,
                                                    size: 24
                                                  }), React.createElement("div", {
                                                    className: "pl-1"
                                                  }, traitsT(traitId))),
                                          key: traitId
                                        });
                            }
                          }))), React.createElement(Select, {
                      native: screenSize >= 4,
                      value: costFilter,
                      onChange: (function (e) {
                          var v = e.target.value;
                          return Curry._1(setCostFilter, (function (param) {
                                        return v;
                                      }));
                        }),
                      className: "w-[90px]",
                      variant: "standard",
                      children: Belt_Array.map([
                            "Any Cost",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5"
                          ], (function (cost) {
                              if (screenSize >= 4) {
                                return React.createElement("option", {
                                            key: cost,
                                            value: cost
                                          }, cost === "Any Cost" ? cost : cost + " gold");
                              } else {
                                return React.createElement(MenuItem, {
                                            value: cost,
                                            children: cost === "Any Cost" ? cost : cost + " gold",
                                            key: cost
                                          });
                              }
                            }))
                    })));
}

var Filters = {
  make: UnitsInfoPage$Filters
};

function UnitsInfoPage(Props) {
  var set = Props.set;
  Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return false;
      });
  var isListMode = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var search = match$1[0];
  var match$2 = React.useState(function () {
        return "any";
      });
  var originFilter = match$2[0];
  var match$3 = React.useState(function () {
        return "any";
      });
  var classFilter = match$3[0];
  var match$4 = React.useState(function () {
        return "Any Cost";
      });
  var costFilter = match$4[0];
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(AdLayout.make, {
                      children: React.createElement("div", {
                            className: "flex flex-col items-center mx-auto max-w-[1072px] mt-8"
                          }, React.createElement(ContentSection.make, {
                                className: "p-3",
                                children: React.createElement("div", {
                                      className: "flex flex-col md:flex-row md:items-center gap-4"
                                    }, React.createElement(UnitsInfoPage$Filters, {
                                          search: search,
                                          setSearch: match$1[1],
                                          originFilter: originFilter,
                                          setOriginFilter: match$2[1],
                                          classFilter: classFilter,
                                          setClassFilter: match$3[1],
                                          costFilter: costFilter,
                                          setCostFilter: match$4[1]
                                        }), React.createElement("div", {
                                          className: "md:ml-4"
                                        }, React.createElement(ListGridSelect.make, {
                                              isListMode: isListMode,
                                              setIsListMode: match[1]
                                            })))
                              }), isListMode ? React.createElement(UnitsInfoPage$ListView, {
                                  search: search,
                                  originFilter: originFilter,
                                  classFilter: classFilter,
                                  costFilter: costFilter
                                }) : React.createElement(UnitsInfoPage$GridView, {
                                  search: search,
                                  originFilter: originFilter,
                                  classFilter: classFilter,
                                  costFilter: costFilter
                                }))
                    }), undefined));
}

var make = UnitsInfoPage;

export {
  Itemization ,
  UnitAbilityInfo ,
  UnitAbility ,
  UnitTraits ,
  UnitStats ,
  Upgrade ,
  UnitCard ,
  UnitsGrid ,
  GridView ,
  ListView ,
  Filters ,
  make ,
  
}
/* cols Not a pure module */
